"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortValueGroupIndexFunction = exports.parseValueGroupItemIndex = void 0;
const number_1 = require("@project-rouge/service-core/data/number");
/**
 * Attempt to parse a value group item index.
 * This should be two numbers separated by a `.`, this looks like a floating point number but it is not.
 *
 * @example `13.1`
 * @example `5.12`
 */
const parseValueGroupItemIndex = (value) => {
    const parts = value.split('.');
    return {
        group: parts[0],
        item: parts[1],
    };
};
exports.parseValueGroupItemIndex = parseValueGroupItemIndex;
/**
 * A sort function that will order value groups in order if their index.
 */
const sortValueGroupIndexFunction = (a, b) => {
    const aa = (0, exports.parseValueGroupItemIndex)(a.index);
    const bb = (0, exports.parseValueGroupItemIndex)(b.index);
    if (aa.item === undefined) {
        return (0, number_1.parseIntegerFromString)(aa.group) - (0, number_1.parseIntegerFromString)(bb.group);
    }
    return (0, number_1.parseIntegerFromString)(aa.item) - (0, number_1.parseIntegerFromString)(bb.item);
};
exports.sortValueGroupIndexFunction = sortValueGroupIndexFunction;
